/**
 * 2.0 화면 메뉴코드. 1.0 GI17 은 그대로 두고 새 코드로 나란히 올린다.
 * 감사로그 MENU_CD(X-Menu-Code)와 라우트 경로 끝이 이 값이다. moms-be `GI17_V2_MENU_CODE` 와 같아야 한다.
 */
export const BIZEST_CANCEL_RESULT_MENU_CODE = 'GI40'

/** 취소요청일자 기본값이 당일인 화주(1.0 systemTask.py:136). 그 밖의 화주는 DEFAULT_PERIOD_DAYS_OTHER_SHIPPER 일 전부터 */
export const BIZEST_CANCEL_DEFAULT_TODAY_SHIPPER = 'MUSINSA'

/** 1.0 메타(MOMS_PROG_INFO MENU_CD=GI17)에 있는 화주 */
export const BIZEST_CANCEL_SHIPPERS = ['MUSINSA', 'NIKE', 'NIKESAMPLE'] as const

/** 사유코드 — MOMS_COMBO_INFO(COMBO_CD=RSN_CODE)·1.0 GI17.js valueFormatter 와 같다 */
export const BIZEST_CANCEL_REASON_CODES = [
  { value: '000', label: '000 취소완료' },
  { value: '001', label: '001 출고진행중' },
  { value: '002', label: '002 출고완료' },
  { value: '003', label: '003 주문없음' },
  { value: '004', label: '004 취소처리중' },
] as const

/** 취소요청일자 기본 기간 — 1.0 systemTask.py:136. MUSINSA 는 당일, 그 밖의 화주는 7일 전부터 */
export const DEFAULT_PERIOD_DAYS_OTHER_SHIPPER = 7

/** 조회 기간 상한(양끝 포함 일수). moms-be 가 넘으면 400 으로 거절한다 — 화면에서 먼저 막는다. */
export const MAX_PERIOD_DAYS = 31

/** 주문번호·주문일련번호 조회 목록 상한. moms-be 가 넘으면 400 으로 거절한다(입력 칸은 1500건까지 받으므로 화면에서 먼저 막는다). */
export const MAX_SEARCH_VALUES = 1000
